import fetchEnv from "../../../utils/FetchEnv";
import { t } from "../../../utils/ResourceUtils";
export const host = fetchEnv()?.REACT_APP_APIURL_HOST;
export const admin_host = fetchEnv()?.REACT_APP_ADMINURL_HOST;

const adminConfig = t("cm.admin_configurations");
const cases = t("cm.cases");

export const permissionList = [
  {
    visible: false,
    isModule: true,
    groupName: t("cm.aci"),
    moduleName: "documentReview",
    moduleDisplayName: t("cm.document_review"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: cases,
    moduleName: "dashboard",
    moduleDisplayName: t("cm.dashboard"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: false,
    groupName: cases,
    moduleName: "createCases",
    moduleDisplayName: t("cm.create_cases"),
    microServiceName: "cvcmUI",
  },
  {
    visible: false,
    isModule: true,
    groupName: cases,
    moduleName: "viewCases",
    moduleDisplayName: t("cm.view_cases"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: cases,
    moduleName: "searchCases",
    moduleDisplayName: t("cm.search_cases"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: cases,
    moduleName: "duplicateCases",
    moduleDisplayName: t("cm.duplicate_cases"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: false,
    groupName: cases,
    moduleName: "exportCases",
    moduleDisplayName: t("cm.export_cases"),
    microServiceName: "cvcmUI",
  },
  {
    visible: false,
    isModule: false,
    groupName: cases,
    moduleName: "cloneCase",
    moduleDisplayName: t("cm.clone_cases"),
    microServiceName: "cvcmUI",
  },
  {
    visible: false,
    isModule: true,
    groupName: cases,
    moduleName: "reports",
    moduleDisplayName: t("cm.reports"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: t("cm.submission"),
    moduleName: "submissionRules",
    moduleDisplayName: t("cm.submission_rules"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: t("cm.submission"),
    moduleName: "qualifiedCases",
    moduleDisplayName: t("cm.qualified_cases"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "queueManagement",
    moduleDisplayName: t("cm.queue_cases"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "triageRules",
    moduleDisplayName: t("cm.triage_rules"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "caseAssignment",
    moduleDisplayName: t("cm.case_assignment"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "roleManagement",
    moduleDisplayName: t("cm.role_management"),
    microServiceName: "adminUI",
    host: admin_host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "userManagement",
    moduleDisplayName: t("cm.user_management"),
    microServiceName: "adminUI",
    host: admin_host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "productConfiguration",
    moduleDisplayName: t("cm.product_configuration"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "studyConfiguration",
    moduleDisplayName: t("cm.study_configuration"),
    microServiceName: "cvcmUI",
    host,
  },
  {
    visible: false,
    isModule: true,
    groupName: adminConfig,
    moduleName: "auditTrail",
    moduleDisplayName: t("cm.audit_trail"),
    microServiceName: "cvcmUI",
    host,
  },
];
